<template>
  <ui-row v-if="authInfo" align-h="center">
    <ui-col :lg="8">
      <ui-heading class="page-title" tag="h4" margin>{{
        firstSetting
          ? $t("helloMessage", { email: authInfo.email })
          : $t("updateProfile")
      }}</ui-heading>
    </ui-col>
    <ui-col :lg="8">
      <ui-card>
        <ui-heading
          tag="h4"
          class="page-title"
          margin
          v-html="authInfo.avatar ? $t('changeAvatar') : $t('uploadAvatar')"
        ></ui-heading>
        <upload
          class="ui-upload-circle"
          ref="upload"
          type="drag"
          :auto-orient="true"
          :max-size="5 * 1024 * 1024"
          file-type="avatar"
          :file-list="fileList"
          @on-success="onSuccess"
          @on-remove="onRemove"
          ><span slot="text">{{ $t("uploadAvatar") }}</span></upload
        >
        <ui-button
          v-if="!firstSetting"
          size="sm"
          @click="save('avatar')"
          ref="avatarButton"
          >{{ $t("saveAvatar") }}</ui-button
        >
        <ui-hr v-if="!firstSetting"></ui-hr>
        <ui-heading tag="h4" margin>{{ $t("setUsername") }}</ui-heading>
        <ui-v :rules="rules" ref="user-form">
          <ui-input
            :placeholder="$t('username')"
            ref="username"
            name="username"
            v-model="user.username"
          >
            <ui-icon slot="prefix" name="user"></ui-icon>
          </ui-input>
        </ui-v>
        <ui-button
          v-if="!firstSetting"
          :disabled="user.username == authInfo.username"
          size="sm"
          @click.native="save('username')"
          >{{ $t("saveUsername") }}</ui-button
        >
        <ui-button
          v-if="firstSetting"
          type="primary"
          full
          @click.native="save()"
          >{{ $t("okStart") }}</ui-button
        >
        <div v-if="!firstSetting && authInfo.provider == 'local'">
          <ui-hr></ui-hr>
          <ui-heading tag="h3">{{ $t("changePassword") }}</ui-heading>
          <ui-v :rules="passwordRules" ref="password-form">
            <ui-input name="password" v-model="user.password">
              <ui-icon slot="prefix" name="lock"></ui-icon>
            </ui-input>
            <ui-input name="password2" v-model="user.password2">
              <ui-icon slot="prefix" name="lock"></ui-icon>
            </ui-input>
          </ui-v>
          <ui-button size="sm" @click.native="save('password')">{{
            $t("savePassword")
          }}</ui-button>
        </div>
      </ui-card>
    </ui-col>
  </ui-row>
</template>
<script>
import api from "../api/index";
import { mapGetters } from "vuex";
// import uploader from "../components/Uploader.vue";
import Upload from "../components/Upload.vue";

export default {
  data() {
    return {
      firstSetting: false,
      type: "",
      user: {
        username: "",
        password: "",
        password2: "",
        avatar: ""
      },
      rules: {
        username: [
          {
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("username")
          },
          {
            type: "minLength",
            length: 3,
            trigger: "submit",
            message: this.$t("username") + this.$t("tooShort", { len: 5 })
          },
          {
            type: "maxLength",
            length: 20,
            trigger: "submit",
            message: this.$t("username") + this.$t("tooLong", { len: 20 })
          },
          {
            type: /^[A-Za-z0-9_._\u4e00-\u9fa5_\。_\、_\@]+$/,
            trigger: "submit",
            message: this.$t("username") + this.$t("notAllowSpecialCharacters")
          }
        ]
      },
      passwordRules: {
        password: [
          {
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("password")
          },
          {
            type: "minLength",
            length: 6,
            trigger: "submit",
            message: this.$t("password") + this.$t("tooShort", { len: 6 })
          }
        ],
        password2: [
          {
            type: "required",
            trigger: "submit",
            message: this.$t("empty") + this.$t("password")
          },
          {
            type: () => {
              if (this.user.password !== this.user.password2) {
                return false;
              } else {
                return true;
              }
            },
            trigger: "submit",
            message: this.$t("passwordNotSame")
          }
        ]
      }
    };
  },

  components: {
    // uploader
    Upload
  },
  computed: {
    ...mapGetters(["authInfo"]),
    fileList() {
      return this.authInfo.avatar
        ? [
            {
              url: this.authInfo.avatar,
              status: "finished"
            }
          ]
        : [];
    }
  },
  mounted() {
    this.firstSetting = this.$route.params.type ? true : false;

    if (this.username) {
      this.$router.push("/profile");
    }
    if (this.authInfo && this.authInfo.username) {
      this.user.username = this.authInfo.username;
    }
    if (this.authInfo && this.authInfo.avatar) {
      this.user.avatar = this.authInfo.avatar;
    }
  },
  methods: {
    checkExist(val, cb) {
      api
        .checkUserExist({
          username: val
        })
        .then(response => {
          cb({
            error: response.data.exist
          });
        });
    },
    onSuccess({ file }) {
      this.user.avatar = file.id;
    },
    onRemove({ file }) {
      this.user.avatar = "";
    },
    save(type) {
      let data = {};
      if (this.$refs["upload"].isUploading()) {
        this.$UiToast.warning(this.$t("uploadingFile"));
        return;
      }
      if (type == "avatar") {
        this.updateProfile(
          {
            avatar: this.user.avatar
          },
          type
        );
      }
      if (type == "username") {
        this.$refs["user-form"]
          .validate()
          .then(data => {
            this.updateProfile(
              {
                username: this.user.username
              },
              type
            );
          })
          .catch(err => {
            console.log(err);
          });
      }

      if (!type) {
        this.$refs["user-form"]
          .validate()
          .then(data => {
            this.updateProfile(
              {
                avatar: this.user.avatar,
                username: this.user.username
              },
              type
            );
          })
          .catch(err => {});
        return;
      }
      if (type == "password") {
        this.$refs["password-form"]
          .validate()
          .then(data => {
            this.updateProfile(
              {
                password: this.user.password
              },
              type
            );
          })
          .catch(err => {});
      }
    },
    updateProfile(data, type) {
      api
        .updateProfile(data)
        .then(res => {
          let userInfo = res.data.userInfo;
          this.$store.commit("AUTH_INFO", userInfo);
          if (type) {
            this.$UiToast({
              message: `${this.$t(type)} ${this.$t("saveSuccess")}`
            });
          }
          if (!type) this.$router.push("/index");
        })
        .catch(err => {
          if (err.response.data.msg == "userNameDuplicated") {
            this.$refs["user-form"].parseError({
              name: "username",
              message: this.$t("userNameDuplicated")
            });
          } else {
            console.log(err);
            this.$UiToast({
              message: `network error, try again later`,
              type: "error"
            });
          }
        });
    }
  }
};
</script>
